import { adminFetch } from "./_client";
import type { AdminDirectoryEntry, GlobalSearchResponse } from "./types";

export function fetchAdminDirectory(token: string, q?: string, limit?: number) {
  const qs = new URLSearchParams();
  if (q) qs.set("q", q);
  if (limit) qs.set("limit", String(limit));
  const suffix = qs.toString() ? `?${qs}` : "";
  return adminFetch<{ admins: AdminDirectoryEntry[] }>(`/admin/admins${suffix}`, token);
}

export function fetchAdminGlobalSearch(token: string, q: string) {
  return adminFetch<GlobalSearchResponse>(`/admin/search?q=${encodeURIComponent(q)}`, token);
}
